import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-zinc-900 group-[.toaster]:border group-[.toaster]:border-zinc-200 group-[.toaster]:rounded-xl group-[.toaster]:shadow-[0_12px_30px_-12px_rgba(0,0,0,0.25)]",
          title: "group-[.toast]:font-medium group-[.toast]:text-sm",
          description: "group-[.toast]:text-zinc-600 group-[.toast]:text-sm group-[.toast]:opacity-100",
          icon: "group-[.toast]:text-gold",
          success: "group-[.toast]:text-zinc-900",
          error: "group-[.toast]:text-zinc-900",
          actionButton:
            "group-[.toast]:bg-zinc-900 group-[.toast]:text-white group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-zinc-100 group-[.toast]:text-zinc-600 group-[.toast]:rounded-full",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
